import React, { useEffect, useRef, useState } from 'react';
import api from '../services/api';

// Cloudflare Turnstile human check for the public submit forms. Pulse
// (GET /api/_meta, proxied to /api/public/feedback/_meta) says which site key
// to use; with no key configured nothing renders and no token is sent.

export function useTurnstileSiteKey() {
  const [siteKey, setSiteKey] = useState(null);
  useEffect(() => {
    api.get('/_meta').then(r => setSiteKey(r.data?.turnstile_site_key || null)).catch(() => setSiteKey(null));
  }, []);
  useEffect(() => {
    if (!siteKey || document.querySelector('script[data-turnstile-loader]')) return;
    const s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    s.async = true; s.defer = true;
    s.dataset.turnstileLoader = 'true';
    document.head.appendChild(s);
  }, [siteKey]);
  return siteKey;
}

// Renders the widget and reports each new token (null when it expires or
// fails). Bump resetKey after a submit to get a fresh token.
export default function Turnstile({ siteKey, onToken, resetKey = 0 }) {
  const ref = useRef(null);
  const widgetId = useRef(null);
  useEffect(() => {
    if (!siteKey) return undefined;
    let cancelled = false;
    const mount = () => {
      if (cancelled) return;
      if (!window.turnstile || !ref.current) { setTimeout(mount, 200); return; }
      widgetId.current = window.turnstile.render(ref.current, {
        sitekey: siteKey, theme: 'dark',
        callback: t => onToken(t),
        'expired-callback': () => onToken(null),
        'error-callback': () => onToken(null)
      });
    };
    mount();
    return () => {
      cancelled = true;
      if (widgetId.current !== null && window.turnstile) window.turnstile.remove(widgetId.current);
      widgetId.current = null;
      onToken(null);
    };
  }, [siteKey, resetKey]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!siteKey) return null;
  return <div ref={ref} style={{ margin: '12px 0' }} />;
}
